import * as THREE from 'three';
import { PhysicsBody, updatePhysics, getAABB } from '../core/physics';

export abstract class Entity {
  body: PhysicsBody;
  health: number;
  maxHealth: number;
  mesh: THREE.Group;
  dead = false;
  invulnerableTime = 0;

  constructor(x: number, y: number, z: number, width: number, height: number, maxHealth: number) {
    this.body = { x, y, z, vx: 0, vy: 0, vz: 0, width, height, onGround: false };
    this.health = maxHealth;
    this.maxHealth = maxHealth;
    this.mesh = new THREE.Group();
    this.mesh.position.set(x, y, z);
  }

  update(dt: number, isSolid: (x: number, y: number, z: number) => boolean): void {
    if (this.dead) return;
    if (this.invulnerableTime > 0) this.invulnerableTime -= dt;

    updatePhysics(this.body, dt, isSolid);
    this.mesh.position.set(this.body.x, this.body.y, this.body.z);
  }

  damage(amount: number): void {
    if (this.invulnerableTime > 0 || this.dead) return;
    this.health -= amount;
    this.invulnerableTime = 0.5;
    if (this.health <= 0) {
      this.health = 0;
      this.dead = true;
    }
  }

  distanceTo(x: number, y: number, z: number): number {
    const dx = this.body.x - x;
    const dy = this.body.y - y;
    const dz = this.body.z - z;
    return Math.sqrt(dx * dx + dy * dy + dz * dz);
  }
}
